// friendlyCaptchaLoader.service.js
(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('FriendlyCaptchaLoader', FriendlyCaptchaLoader);

  FriendlyCaptchaLoader.$inject = ['$q', '$window'];

  function FriendlyCaptchaLoader($q, $window) {
    function load(element) {
      if (!$window.frcaptcha) {
        return $q.reject(new Error('Friendly Captcha SDK not loaded'));
      }

      if (element) {
        $window.frcaptcha.attach(element);
      }

      return $q.resolve();
    }

    return {load: load};
  }
})();
